import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSwapPackage = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 26 26",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M14.46.75v10.29h10.29c0-5.68-4.6-10.29-10.29-10.29",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "currentColor",
			fillRule: "evenodd",
			d: "M11.04 4.18a10.29 10.29 0 1 0 10.28 10.28H11.04z",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M14.46.75v10.29h10.29c0-5.68-4.6-10.29-10.29-10.29",
			clipRule: "evenodd"
		}),
		/* @__PURE__ */ _jsx("path", {
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: 1.5,
			d: "M11.04 4.18a10.29 10.29 0 1 0 10.28 10.28H11.04z",
			clipRule: "evenodd"
		})
	]
});
export { SvgSwapPackage as ReactComponent };
